import Text from '@/components/Text';

// Needed to have for muxPlayer.web to function
const MuxPlayerScreen = () => {
  return <Text>Error loading player</Text>;
};

export default MuxPlayerScreen;
